/**
 * Resolves whether preserve-trip-type calendar semantics are active.
 * Requires unified picker (legacy_date_picker off) and opt-in via GrowthBook or data-prop.
 */
export default function resolveEffectivePreserveTripType({
  legacyDatePicker,
  growthbookPreserveTripType,
  configPreserveTripType,
}) {
  const showUnifiedPicker = !legacyDatePicker;

  return (
    showUnifiedPicker &&
    (Boolean(growthbookPreserveTripType) || Boolean(configPreserveTripType))
  );
}
